var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"binsess-center-contain"}},[_c('div',{staticClass:"flex-center flex"})])
}]

export { render, staticRenderFns }